import { useCurrentStateAndParams } from "@uirouter/react";

import { SI_SEARCH_ROUTES } from "app/common/constants/ad-intelligence-routes";
import { ROUTES } from "single-spa/react-app/config/solutions25/adIntelligence/searchAdvertising/searchAdvertisingConstants";

export interface IKeywordAnalysisNavigationTargets {
    websiteKeywordsState: string;
    monitorKeywordsState: string;
    keywordAdsState: string;
    keywordSerpPlayersState: string;
}

const keywordResearchNavigationTargets: IKeywordAnalysisNavigationTargets = {
    websiteKeywordsState: "organicsearch_websites_v2_traffic_keywords",
    monitorKeywordsState: "digitalsuite_monitorkeywords",
    keywordAdsState: "paidsearch_keywordAnalysis_serp_ads",
    keywordSerpPlayersState: "organicsearch_keywordAnalysis_overview_2",
};

const searchAdvertisingNavigationTargets: IKeywordAnalysisNavigationTargets = {
    websiteKeywordsState: ROUTES.keywords,
    monitorKeywordsState: ROUTES.monitorKeywords,
    keywordAdsState: ROUTES.keywordAds,
    keywordSerpPlayersState: ROUTES.serpPlayers,
};

const keywordAnalysisNavigationTargetsMap: Record<string, IKeywordAnalysisNavigationTargets> = {
    /* eslint-disable @typescript-eslint/naming-convention */
    organicsearch_keywordAnalysis_2: keywordResearchNavigationTargets,
    organicsearch_trafficAnalysis_2: keywordResearchNavigationTargets,
    organicsearch_keywordAnalysis_overview_2: keywordResearchNavigationTargets,
    paidsearch_keywordAnalysis_serp_ads: keywordResearchNavigationTargets,
    digitalsuite_keywordAnalysis_serpSnapshot: keywordResearchNavigationTargets,
    digitalsuite_findkeywords_keywordGeneratorTool: keywordResearchNavigationTargets,
    /* eslint-enable @typescript-eslint/naming-convention */
    [ROUTES.serpPlayers]: searchAdvertisingNavigationTargets,
    [ROUTES.keywordLandingPages]: searchAdvertisingNavigationTargets,
    [ROUTES.keywordAds]: searchAdvertisingNavigationTargets,
    // Sales Intelligence mirror of Search Advertising.
    [SI_SEARCH_ROUTES.serpPlayers]: searchAdvertisingNavigationTargets,
    [SI_SEARCH_ROUTES.keywordLandingPages]: searchAdvertisingNavigationTargets,
    [SI_SEARCH_ROUTES.keywordAds]: searchAdvertisingNavigationTargets,
};

export const useKeywordAnalysisNavigationTargets = (): IKeywordAnalysisNavigationTargets => {
    const { state } = useCurrentStateAndParams();
    const navigationTargets = keywordAnalysisNavigationTargetsMap[state.name];

    if (!navigationTargets) {
        throw new Error(
            `No keyword analysis navigation targets configured for state: ${state.name}. ` +
                `Available states: ${Object.keys(keywordAnalysisNavigationTargetsMap).join(", ")}`,
        );
    }

    return navigationTargets;
};
